import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Layout from "./components/Layout";
import { SettingsProvider } from "./lib/settings";
import Home from "./pages/Home";
import GamePage from "./pages/GamePage";
import { ListPage, CategoryPage, TagPage, SearchPage, CategoriesPage } from "./pages/Listings";
import { MyGames } from "./pages/MyGames";
import { StaticPage, ContactPage, RandomGame, NotFound } from "./pages/StaticPages";
import { AuthProvider, Protected } from "./admin/AuthContext";
import AdminLogin from "./admin/AdminLogin";
import AdminLayout from "./admin/AdminLayout";
import Dashboard from "./admin/Dashboard";
import AdminGames from "./admin/AdminGames";
import AdminCategories from "./admin/AdminCategories";
import { AdminAds, AdminSettings } from "./admin/AdminAds";

function AdminRoutes() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="login" element={<AdminLogin />} />
        <Route element={<Protected><AdminLayout /></Protected>}>
          <Route index element={<Dashboard />} />
          <Route path="giochi" element={<AdminGames />} />
          <Route path="categorie" element={<AdminCategories />} />
          <Route path="pubblicita" element={<AdminAds />} />
          <Route path="impostazioni" element={<AdminSettings />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}

export default function App() {
  return (
    <SettingsProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/admin/*" element={<AdminRoutes />} />
          <Route element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="gioco/:slug" element={<GamePage />} />
            <Route path="nuovi-giochi" element={<ListPage kind="new" />} />
            <Route path="migliori-giochi" element={<ListPage kind="best" />} />
            <Route path="giochi-in-evidenza" element={<ListPage kind="featured" />} />
            <Route path="categoria/:slug" element={<CategoryPage />} />
            <Route path="tag/:slug" element={<TagPage />} />
            <Route path="categorie" element={<CategoriesPage />} />
            <Route path="tags" element={<CategoriesPage tags />} />
            <Route path="cerca" element={<SearchPage />} />
            <Route path="giocati" element={<MyGames kind="played" />} />
            <Route path="preferiti" element={<MyGames kind="favorites" />} />
            <Route path="casuale" element={<RandomGame />} />
            <Route path="chi-siamo" element={<StaticPage kind="about" />} />
            <Route path="termini" element={<StaticPage kind="terms" />} />
            <Route path="privacy" element={<StaticPage kind="privacy" />} />
            <Route path="contatti" element={<ContactPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </SettingsProvider>
  );
}
